import { render, staticRenderFns } from "./IconTextLink.vue?vue&type=template&id=63e9a2e6&"
import script from "./IconTextLink.vue?vue&type=script&lang=js&"
export * from "./IconTextLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63e9a2e6')) {
      api.createRecord('63e9a2e6', component.options)
    } else {
      api.reload('63e9a2e6', component.options)
    }
    module.hot.accept("./IconTextLink.vue?vue&type=template&id=63e9a2e6&", function () {
      api.rerender('63e9a2e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextLink.vue"
export default component.exports